// extracted by mini-css-extract-plugin
export default {"header-container":"description-card_header-container__Fsvib","container":"description-card_container__tDXNE"};